<template>
  <div class="project-list">
    <div class="window-container">
      <div class="page-container">
        <v-data-table
          v-model="selectedProjects"
          :headers="headers"
          :items="projects"
          :items-per-page="100"
          item-key="uuid"
          :loading="loading"
          :show-select="remote"
          :footer-props="{
            itemsPerPageOptions: [15, 50, 100]
          }"
          show-expand
          hide-default-header
          @click:row="goToProjectPage"
        >
          <!-- Checkbox -->
          <template #item.data-table-select="{ item, isSelected, select }">
            <v-simple-checkbox
              :value="isSelected"
              :ripple="false"
              @input="val => select(val)"
            />
          </template>

          <!-- Patient -->
          <template #item.patient.fullname="{ item }">
            <span>{{ item.patient.fullname }}</span>
            <br>
            <span style="font-size: 10px; font-weight: 200">{{
              item.center
            }}</span>
          </template>

          <template #item.created_at="{value}">
            {{ value }}
          </template>

          <template #item.action="{ item }">
            <!--TODO: Decomment to active delete feature -->
            <!-- <v-icon v-if="!remote" @click.stop="$emit('delete-project', item)"
              >mdi-delete</v-icon
            > -->
            <v-icon
              v-if="!item.product_uuid"
              color="red"
            >
              mdi-alert
            </v-icon>
            <v-icon v-if="item.idc_locked">
              mdi-lock
            </v-icon>
            <v-icon
              v-if="!remote && item.initial_transfer_at == ''"
              @click.stop="$emit('delete-project', item)"
            >
              mdi-delete
            </v-icon>
            <v-icon
              v-if="!remote && item.transferable && !item.idc_locked"
              class="ml-8"
              @click.stop="$emit('send-project', item)"
            >
              mdi-send
            </v-icon>
          </template>

          <template #expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <ul>
                <li>Adresse: {{ item.patient.fullAddress }}</li>
                <li>Tél: {{ item.patient.phone }}</li>
                <li>Centre: {{ item.center }}</li>
              </ul>
            </td>
          </template>
        </v-data-table>

        <div class="save-container">
          <v-btn
            v-if="remote"
            class="save"
            :disabled="loading"
            @click="$emit('sync-selected', selectedProjects)"
          >
            Synchroniser
          </v-btn>

          <v-btn
            v-if="remote"
            class="save"
            :disabled="loading"
            @click="$router.push('/')"
          >
            Base Tablette
          </v-btn>

          <!-- TODO: Decomment to activate delivered feature -->
          <!-- <v-btn
            class="save"
            v-if="remote"
            @click="$emit('set-delivered-projects', selectedProjects)"
            :disabled="loading"
            >Définir comme livré</v-btn
          > -->

          <v-btn
            v-if="!remote"
            class="save"
            :disabled="loading"
            @click="$router.push({ name: 'CreateProject' })"
          >
            Nouvelle fiche
          </v-btn>

          <v-btn
            v-if="!remote"
            class="save"
            :disabled="loading"
            @click="$router.push('/remote')"
          >
            Base Serveur
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectList",

  props: {
    projects: {
      type: Array,
      default: () => []
    },

    loading: {
      type: Boolean,
      default: false
    },

    remote: {
      type: Boolean,
      default: false
    },

    savedProjects: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showDebug: false,
      headers: [
        {
          text: "Patient",
          value: "patient.fullname"
        },
        {
          text: "Fiche",
          value: "product_model_trans"
        },
        {
          text: "Date",
          value: "created_at"
        },
        { text: "Actions", value: "action", sortable: false },
        { text: "", value: "data-table-expand" }
      ],

      selectedProjects: []
    };
  },

  watch: {
    savedProjects() {
      this.savedProjects.forEach(project =>
        this.selectedProjects.push(project)
      );
    }
  },

  methods: {
    /**
     * Go to project page
     *
     * @param project Project clicked
     */
    goToProjectPage(project) {
      // Disable click when we are in remote mode
      if (this.remote) {
        return;
      }

      this.$router.push({
        name: "ProjectPage",
        params: { projectUuid: project.uuid }
      });
    }
  }
};
</script>

<style lang="scss">
.project-list {
  .window-container {
    height: calc(100vh - 56px - 60px);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px 45px;
  }
  .v-data-table {
    table {
      border: none !important;
      * {
        border-color: transparent !important;
      }
      tbody {
        td {
          padding: 15px;
          text-align: end !important;
          &:nth-last-child(5) {
            text-align: start !important;
            font-weight: bold;
            font-size: 13px !important;
            color: #006064;
            text-transform: uppercase;
          }
          &:nth-last-child(4) {
            font-weight: bold;
            font-size: 13px !important;
            text-align: center !important;
            text-transform: uppercase;
            color: #880e4f;
          }
          &:nth-last-child(3) {
            color: #880e4f;
            font-size: 10px !important;
          }
          &:nth-last-child(2) {
            padding: 0 !important;
            i {
              font-size: 20px !important;
            }
          }
        }
        tr {
          border-bottom: 1px solid rgba(159, 159, 159, 0.2) !important;
        }
      }
    }
    .v-data-footer {
      border-top: none !important;
    }
  }
}
</style>
